// TouchDesignerRedirect.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function TouchDesignerRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Navigate to /help with state to scroll to the TouchDesigner section.
    navigate('/help', { state: { scrollTo: 'touchdesigner' } });
  }, [navigate]);

  return null;
}

export default TouchDesignerRedirect;
